<template>
  <div class="home">
    <Logo />
    <div class="columns">
      <div
        class="column"
        v-for="(item, key) in items"
        :key="key"
        @click="go(item.value)"
      >
        <div class="header">
          <img :src="item.image">
        </div>
        <div class="body">
          <span>{{item.name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Logo";
export default {
  name: "home",
  components: {
    Logo
  },
  data() {
    return {
      items: [
        {
          name: "Rep. Dominicana",
          image:
            "https://ak8.picdn.net/shutterstock/videos/2284298/thumb/1.jpg",
          value: "do"
        },
        {
          name: "Mexíco",
          image:
            "https://ak4.picdn.net/shutterstock/videos/1821584/thumb/1.jpg",
          value: "mx"
        },
        {
          name: "España",
          image:
            "https://ak3.picdn.net/shutterstock/videos/9213653/thumb/1.jpg",
          value: "es"
        },
        {
          name: "Brasil",
          image:
            "https://ak9.picdn.net/shutterstock/videos/17844049/thumb/1.jpg",
          value: "br"
        },
        {
          name: "Jamaica",
          image:
            "https://ak9.picdn.net/shutterstock/videos/6659549/thumb/1.jpg",
          value: "jm"
        }
      ]
    };
  },
  methods: {
    go(value) {
      this.$router.push({ path: `/country/${value}` });
    }
  }
};
</script>
<style scoped>
.home {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  flex-direction: column;
}
.home .columns {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 70%;
}
.home .columns .column {
  position: relative;
  width: 256px;
  height: 170px;
  margin: 20px;
  webkit-box-shadow: 6px 22px 48px -25px #000;
  box-shadow: 6px 22px 48px -25px #000;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  cursor: pointer;
}
.home .columns .column .header,
.home .columns .column .header img,
.home .columns .column .body {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
}
.home .columns .column .body {
  position: absolute;
  justify-content: center;
  align-items: flex-end;
  top: 0px;
}
.home .columns .column .body span {
  display: block;
  padding: 10px 50px 10px 50px;
  background: #fff;
  margin-bottom: 30px;
  font-family: "ImbueFT";
  font-weight: 700;
  line-height: 0.9;
  font-size: 26px;
  letter-spacing: 1.5px;
}
</style>

